import React from 'react';

const PermissionNotice = ({ message, className = '' }) => {
  return (
    <div className={`text-center text-muted f-14 ${className}`.trim()}>
      {message || 'You do not have permission to view this section.'}
    </div>
  );
};

export default PermissionNotice;
